import gql from 'graphql-tag';

const WDT_STUDENT_ERROR_QUERY = gql`
  query wdtStudentErrorsReport(
    $where: WdtStudentErrorsReportWhereInput!
    $dateRange: DateRangeInput
  ) {
    wdtStudentErrorsReport(where: $where, dateRange: $dateRange) {
      studentId
      characterOrder
      characterGroups {
        id
        name
      }
      characterErrors {
        character {
          id
          characterGroupIds
          character
        }
        errors {
          type
          count
        }
      }
    }
  }
`;

export default WDT_STUDENT_ERROR_QUERY;
